import { BehaviorSubject } from 'rxjs';
export const getClientDetailsStore = () => {
    const getInitialState = () => ({
        name: '',
        fiscalIdentifier: '',
        admins: []
    });
    const clientDetailsSubject = new BehaviorSubject(getInitialState());
    const setClientDetails = (details) => clientDetailsSubject.next(details);
    const subscribe = (callback) => clientDetailsSubject.subscribe(callback);
    const reset = () => clientDetailsSubject.next(getInitialState());
    return {
        getInitialState,
        setClientDetails,
        subscribe,
        reset
    };
};
